import { MarkerGlyph } from './ForecastChart';

interface Props {
  renewalPct: number; // 0..1
  onChange: (pct: number) => void;
  atRiskCount: number;
  poolCount: number;
  renewCount: number;
  dropCount: number;
}

const PRESETS = [0, 25, 50, 75, 100];

/** Renewal what-if, as a Client Dashboard panel with a segmented preset control. */
export function RenewalSlider({ renewalPct, onChange, atRiskCount, poolCount, renewCount, dropCount }: Props) {
  const pct = Math.round(renewalPct * 100);

  return (
    <div className="ds-panel" style={{ marginBottom: 22 }}>
      <h3>
        Renewal forecast
        <span>
          {atRiskCount} finishing in this view · {poolCount} subject to the slider ·{' '}
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: 'var(--rag-green-ink)' }}>
            <MarkerGlyph kind="extended" /> {renewCount} renew
          </span>{' '}
          ·{' '}
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: 'var(--rag-red-ink)' }}>
            <MarkerGlyph kind="finish" /> {dropCount} drop
          </span>
        </span>
      </h3>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 14 }}>
        <div style={{ fontSize: 20, fontWeight: 500, letterSpacing: '-0.01em' }}>
          What if <span style={{ fontFamily: 'var(--mono)', fontWeight: 700 }}>{pct}%</span>{' '}
          <em style={{ color: 'var(--text-3)' }}>renew?</em>
        </div>
        <div className="seg-toggle" role="group" aria-label="Renewal presets">
          {PRESETS.map((p) => (
            <button key={p} className={pct === p ? 'active' : ''} onClick={() => onChange(p / 100)}>
              {p === 100 ? 'All renew' : p === 0 ? 'None' : `${p}%`}
            </button>
          ))}
        </div>
      </div>

      <input
        type="range"
        min={0}
        max={100}
        step={5}
        value={pct}
        onChange={(e) => onChange(Number(e.target.value) / 100)}
        className="saragossa-slider"
        style={{ ['--fill' as string]: `${pct}%` }}
        aria-label="Renewal percentage"
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--text-3)', marginTop: 6 }}>
        <span>0%</span>
        <span>25%</span>
        <span>50%</span>
        <span>75%</span>
        <span>100%</span>
      </div>
    </div>
  );
}
